import { render, staticRenderFns } from "./SubscribeSection.vue?vue&type=template&id=490b7e98&lang=pug&"
import script from "./SubscribeSection.vue?vue&type=script&lang=js&"
export * from "./SubscribeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports